import type { BankAccount } from './api';
import { bankDisplayName, TRY_CURRENCY } from './banks';

/**
 * BANKAYA GORE GRUPLAMA.
 *
 * Mobildeki karar birebir korundu: bir bankada birden cok para birimi hesabi
 * olmasi normal ve kullanici onlari birlikte dusunuyor ("Garanti'deki
 * hesaplarim"). Duz bir liste ayni logoyu ve ayni banka adini ust uste
 * tekrarlar, hesap adlari arasindaki fark kaybolur.
 *
 * Ayri bir modul cunku tek testi olan saf bir donusum: bilesenin icinde
 * kalsaydi ancak DOM uzerinden dolayli olarak sinanabilirdi.
 */

export type BankGroup = Readonly<{
  /** Gruplama anahtari — sunucudaki `accountCode`. */
  bankCode: string;
  /** Karta yazilan ad (katalogdan; yoksa sunucunun etiketi). */
  displayName: string;
  accounts: readonly BankAccount[];
  /**
   * Grupta TRY hesabi var mi. Yoksa ekran "TRY hesabi ekle" kisayolunu gosterir:
   * takasin karsi bacagi neredeyse her zaman TRY ve eksikligi ancak islem
   * ortasinda fark ediliyor.
   */
  hasTry: boolean;
}>;

export const groupAccountsByBank = (accounts: readonly BankAccount[]): BankGroup[] => {
  const buckets = new Map<string, BankAccount[]>();

  for (const account of accounts) {
    const existing = buckets.get(account.bankCode);
    if (existing) existing.push(account);
    else buckets.set(account.bankCode, [account]);
  }

  return [...buckets.entries()]
    .map(([bankCode, list]) => {
      // Sunucudan gelen etiket YALNIZ katalogda kod yoksa devreye girer; ilk
      // satirdaki bos olabilir, o yuzden dolu olan ilk etiket araniyor.
      const fallbackLabel = list.find((account) => account.bankLabel !== '')?.bankLabel;
      return {
        bankCode,
        displayName: bankDisplayName(bankCode, fallbackLabel),
        // Grup ici sira: para birimine gore, kullanici hesaplarini hep ayni
        // yerde bulsun. Sunucunun siralamasi kod+JSONB alanina dayaniyor ve
        // hesap eklendikce degisiyor.
        accounts: [...list].sort((a, b) => a.currency.localeCompare(b.currency, 'tr')),
        hasTry: list.some((account) => account.currency === TRY_CURRENCY),
      };
    })
    .sort((a, b) => a.displayName.localeCompare(b.displayName, 'tr'));
};
